import React from 'react';
import { useSelector } from 'react-redux';
import useGarbageCollector from '../../../../libs/garbagecollector/garbageCollectorHooks';
import Loadable from '../../../components/loadable/Loadable';
import Popup from '../../../components/popup/Popup';
import AddEditIntermediary from './AddEditIntermediary';
import styles from './Intermediary.styles';
import { componentKey } from './IntermediarySlice';
import { PAGE_STATE, PAGE_STATE_MESSAGE_MAP } from '../../constants/constants';

export default function Intermediary({ intermediaryIdForEdit = null, isPopup = false, isPopupOpen = false, onPopupCloseCb = () => {}, onSubmitCb = () => {}}) {
    useGarbageCollector(componentKey);
    const { loadingState } = useSelector(state => state[componentKey]);

    const AddIntermediaryComponent = (
        <div style={styles.intermediaryParentContainer}>
            <Loadable currentState={loadingState.state} loadingStates={[PAGE_STATE.LOADING]} messageMap={PAGE_STATE_MESSAGE_MAP} isNewLoadable={true}>
                <AddEditIntermediary intermediaryIdForEdit={intermediaryIdForEdit} onPopupCloseCb={onPopupCloseCb} onSubmitCb={onSubmitCb} />
            </Loadable>
        </div>
    );

    return <>
        {isPopup ?
            <Popup title={""} onCloseCb={onPopupCloseCb} isPopupOpen={isPopupOpen} customPopupSyles={styles.popupStyles} overlayStyles={styles.popupoOverlay} childrenStyles={styles.popupChildrenStyles}>
                {AddIntermediaryComponent}
            </Popup>

        :
            AddIntermediaryComponent
        }
    </>
}